module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "name": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名",
      "autofocus": "",
      "tabindex": "1"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }, [(_vm.validation.hasError('username')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('username')))]) : _vm._e()]), _vm._v(" "), _c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "tabindex": "2"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }, [(_vm.validation.hasError('password')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('password')))]) : _vm._e()]), _vm._v(" "), _c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "再次输入密码",
      "tabindex": "3"
    },
    model: {
      value: (_vm.repeat),
      callback: function($$v) {
        _vm.repeat = $$v
      },
      expression: "repeat"
    }
  }, [(_vm.validation.hasError('repeat')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('repeat')))]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "native-type": "submit"
    }
  }, [_vm._v("注册")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-083cc72f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/Register.vue
// module id = 263
// module chunks = 0